import { gql } from '@apollo/client';
import AddressFragment from "../Address";


const IncomingOrdersDetailFragment = gql`
	fragment SortedAddressField on AddressField {
    __typename
    field
    label
    value
  }
	
fragment IncomingOrdersDetailFragment on IncomingOrdersItem
{
	      supplierOrderId
        supplierOrderNo
        orderReference
        supplierOrderReference
        orderConfirmationSent
        transportUpdateSent
        comment
        companyOrderno
        costPlaceOrder
        costPlaceOrder2
        costPlaceOrder3
        currencyCode
        deliveryDateWish
        email
        deliveryAddress {
          __typename
          ...AddressFields
        }
        invoiceAddress {
          __typename
          ...AddressFields
        }
        orderDate
        ordererAddress {
          __typename
          ...AddressFields
        }
        orderId
        status
        orderStatus
        sumInclVat
        sumExclVat
        username
        orderRows {
          __typename
          amount
          orderRowType
          productType
          id
          price
          product
					deliveryDateWish
					confirmedDeliveryDate
          productType
          stockInfo {
            __typename
            stockLocation
            picked
            pickedBy
          }
				  supplierOrderStatusId
          weight
        }
        vatAmounts {
          name
          vatAmount
          vatPercentage
        }

  			sortedAddressFields {
	  			deliveryAddress { ...SortedAddressField }
		  		invoiceAddress { ...SortedAddressField }
			  	ordererAddress { ...SortedAddressField }
			  }

        supplierOrderStatuses {
				  id
				  actions
				  color
				  productionStatus
				  name
          userMustConfirmAction
			  }

}

  fragment SortedAddressField on AddressField {
    __typename
    field
    label
    value
  }

  ${AddressFragment}
`;

export default IncomingOrdersDetailFragment;
